import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { StockFilterRangeProps } from './StockFilterRange.types';

const isHandleChangeNumber = (
  event: React.ChangeEvent<HTMLInputElement>
): boolean => {
  const value = event.target.value;
  const regNumber = /^[0-9]+$/;

  return regNumber.test(value) || !value;
};

function StockFilterRange({
  label,
  minValue,
  maxValue,
  values,
  onBlur,
}: StockFilterRangeProps) {
  const [minState, setMinState] = useState(values.min || '');
  const [maxState, setMaxState] = useState(values.max || '');

  useEffect(() => {
    setMaxState(values.max);
    setMinState(values.min);
  }, [values]);

  function onChangeMinHandle(event: React.ChangeEvent<HTMLInputElement>) {
    if (isHandleChangeNumber(event)) {
      setMinState(event.target.value);
    }
  }

  function onChangeMaxHandle(event: React.ChangeEvent<HTMLInputElement>) {
    if (isHandleChangeNumber(event)) {
      setMaxState(event.target.value);
    }
  }

  function onBlurMinHandle(event: React.FocusEvent<HTMLInputElement>) {
    if (minState === values.min) {
      return;
    }

    if (minValue && maxValue) {
      if (Number(event.target.value) > maxValue) {
        setMinState(String(maxValue));
        onBlur?.({ min: String(maxValue), max: maxState });
      } else if (
        Number(event.target.value) < minValue &&
        Number(event.target.value) >= 0
      ) {
        setMinState(String(minValue));
        onBlur?.({ min: String(minValue), max: maxState });
      } else if (event.target.value === '') {
        setMinState('');
        onBlur?.({ min: '', max: maxState });
      } else {
        if (Number(event.target.value) > Number(maxState) && maxState !== '') {
          setMaxState(event.target.value);
          onBlur?.({ min: event.target.value, max: event.target.value });
        } else {
          onBlur?.({ min: minState, max: maxState });
        }
      }
    } else {
      if (Number(event.target.value) > Number(maxState) && maxState !== '') {
        setMaxState(event.target.value);
        onBlur?.({ min: event.target.value, max: event.target.value });
      } else {
        onBlur?.({ min: minState, max: maxState });
      }
    }
  }

  function onBlurMaxHandle(event: React.FocusEvent<HTMLInputElement>) {
    if (maxState === values.max) {
      return;
    }

    if (minValue && maxValue) {
      if (Number(event.target.value) > maxValue) {
        setMaxState(String(maxValue));
        onBlur?.({ min: minState, max: String(maxValue) });
      } else if (
        Number(event.target.value) < minValue &&
        Number(event.target.value) >= 0
      ) {
        setMaxState(String(minValue));
        onBlur?.({ min: minState, max: String(minValue) });
      } else if (event.target.value === '') {
        setMaxState('');
        onBlur?.({ min: minState, max: '' });
      } else {
        if (Number(event.target.value) < Number(minState)) {
          setMinState(event.target.value);
          onBlur?.({ min: event.target.value, max: event.target.value });
        } else {
          onBlur?.({ min: minState, max: maxState });
        }
      }
    } else {
      if (
        Number(event.target.value) < Number(minState) &&
        event.target.value !== ''
      ) {
        setMinState(event.target.value);
        onBlur?.({ min: event.target.value, max: event.target.value });
      } else {
        onBlur?.({ min: minState, max: maxState });
      }
    }
  }

  return (
    <Component>
      <Label>{label}</Label>

      <Inputs>
        <Input
          type="tel"
          placeholder="От"
          value={minState}
          onChange={onChangeMinHandle}
          onBlur={onBlurMinHandle}
        />
        <Input
          type="tel"
          placeholder="До"
          value={maxState}
          onChange={onChangeMaxHandle}
          onBlur={onBlurMaxHandle}
        />
      </Inputs>
    </Component>
  );
}

export default StockFilterRange;

const Component = styled.div`
  position: relative;
  width: 100%;
`;

const Label = styled.p`
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.blue100};
`;

const Inputs = styled.div`
  display: flex;
  height: 40px;
  margin-top: 10px;
`;

const Input = styled.input`
  display: block;
  width: 100%;
  height: 100%;
  padding: 11px 15px 10px;
  font-size: 16px;
  line-height: 19px;
  background-clip: padding-box;
  appearance: none;
  color: ${(props) => props.theme.black200};
  background: ${(props) => props.theme.white_1};
  border: 1px solid ${(props) => props.theme.gray1000};

  &:first-child {
    border-radius: 6px 0 0 6px;
  }

  &:last-child {
    margin-left: -1px;
    border-radius: 0 6px 6px 0;
  }

  &::placeholder {
    color: ${(props) => props.theme.gray1500};
    opacity: 1;
  }
`;
